var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,1,-15,-14.9)"},React.createElement("path",{"d":"M20 21.5225H22.0641V19.541C22.0641 18.6328 22.0641 17.3118 22.7246 16.4861C23.3851 15.5779 24.3758 15 25.9445 15C28.504 15 29.5773 15.3303 29.5773 15.3303L29.0819 18.3851C29.0819 18.3851 28.2563 18.1374 27.4307 18.1374C26.6051 18.1374 25.9445 18.3851 25.9445 19.2107V21.5225H29.2471L28.9994 24.4948H25.9445V34.8152H22.0641V24.4948H20V21.5225Z","fill":"currentColor"})));
}

Facebook.defaultProps = {"viewBox":"0 0 20 20","fill":"none","style":{"color":"#39424A"}};

module.exports = Facebook;

Facebook.default = Facebook;
